import { openBlock as n, createElementBlock as i, renderSlot as r, createCommentVNode as h, createTextVNode as d, createElementVNode as o, normalizeClass as p } from "vue";
/* empty css                    */
import u from "./design-system.es128.js";
const c = {
  name: "DsCollapsible",
  props: {
    /**
     * Controls the open state of the collapsible.  This makes the collapsible controlled and will not work with uncontrolled options.
     */
    isOpen: {
      type: Boolean,
      default: null
    }
  },
  emits: ["toggle"],
  data() {
    return {
      slotContentObserver: Object,
      isOpenInternal: !1
    };
  },
  computed: {
    isControlled() {
      return this.isOpen === !0 || this.isOpen === !1;
    },
    hasHeader() {
      return this.$slots.header;
    }
  },
  watch: {
    isOpenInternal(e) {
      this.setContentHeight(), this.isControlled || this.$emit("toggle", e);
    },
    isOpen: {
      handler(e) {
        this.isControlled && (this.isOpenInternal = e);
      },
      immediate: !0
    }
  },
  mounted() {
    this.slotContentObserver = new MutationObserver(this.setContentHeight), this.slotContentObserver.observe(this.$refs.inner, {
      attributes: !0,
      subtree: !0,
      childList: !0
    }), this.setContentHeight();
  },
  beforeUnmount() {
    this.slotContentObserver.disconnect();
  },
  methods: {
    setContentHeight() {
      this.$refs.content && (this.$refs.content.style.height = this.isOpenInternal ? `${this.$refs.inner.offsetHeight}px` : 0);
    },
    open() {
      this.isOpenInternal = !0;
    },
    toggle() {
      if (this.isControlled) {
        this.$emit("toggle");
        return;
      }
      this.isOpenInternal = !this.isOpenInternal;
    }
  }
}, f = { class: "collapsible" }, m = {
  ref: "inner",
  class: "collapsible-inner"
};
function g(e, t, O, C, l, s) {
  return n(), i("div", f, [
    s.hasHeader ? (n(), i("header", {
      key: 0,
      onClick: t[0] || (t[0] = (...a) => s.toggle && s.toggle(...a))
    }, [
      r(e.$slots, "header", {}, void 0, !0)
    ])) : h("", !0),
    t[1] || (t[1] = d()),
    o("div", {
      ref: "content",
      class: p(["collapsible-content", { active: l.isOpenInternal }])
    }, [
      o("div", m, [
        r(e.$slots, "default", {}, void 0, !0)
      ], 512)
    ], 2)
  ]);
}
const I = /* @__PURE__ */ u(c, [["render", g], ["__scopeId", "data-v-187ce4ef"]]);
export {
  I as default
};
//# sourceMappingURL=design-system.es47.js.map
